<ul>
  @for (button of buttons(); track button.code) {
    <li
      (click)="onClick(button)"
      [class.closeable]="button.closeable"
      data-test="breadcrumb"
    >
      @if (button.icon; as icon) {
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <use [attr.xlink:href]="icon"></use>
        </svg>
      }
      <span>{{ button.name }}</span>
      @if (button.closeable) {
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <use [attr.xlink:href]="SvgSpriteIcon.Close16"></use>
        </svg>
      }
    </li>
  }
</ul>
